import type { Chart, ChartType, TooltipModel } from 'chart.js';
import { useCallback, useState } from 'react';

type ChartToolipProps = {
  chart: Chart | null;
};

const useExplorerChartTooltip = (props: ChartToolipProps) => {
  const [tooltipData, setTooltipData] = useState<TooltipModel<any> | null>(
    null,
  );

  const chartTooltip = useCallback(
    <T extends ChartType>(tooltipModel: {
      tooltip: TooltipModel<T>;
      replay?: boolean;
    }) => {
      const tooltip = tooltipModel.tooltip;

      if (tooltip.opacity != 1) {
        setTooltipData(null);
        return;
      }

      const top = tooltipModel.tooltip.y;
      if (tooltipData?.y != top) {
        setTooltipData(tooltip);
      }
    },

    [tooltipData?.y],
  );

  const hideTooltip = useCallback(() => setTooltipData(null), []);

  return {
    chartTooltip,
    tooltipData,
    hideTooltip,
  };
};

export { useExplorerChartTooltip };
